<template>
    <section class="chat" ref="chat">
        <div class="header">
            <div class="header-wrap">
                <div class="header-avatar">
                    <img class="header__avatar avatar__img" src="../assets/img/person-goroskop.png" alt/>
                </div>
                <div class="header-text">
                    <div class="header-text__name">{{person}}</div>
                    <div class="header-text__who">Certified Astrologer</div>
                    <div class="header-text__answers">Answers: 9,342 - Forecast accuracy: 97%</div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="blow" ref="blow">
                <div
                        class="message"
                        v-for="(message,index) in delivered"
                        :key="index"
                        :class="{'message--user' : message.user}"
                >
                    <span class="message__text" v-html="message.text"></span>
                    <div class="container-button" v-show="message.type === 'question' && index === idx - 1">
                        <button 
                            class="container__button" 
                            v-for="(answer,id) in message.answers"
                            :key="id"
                            :class="{'message--user' : message.user}"
                            @click="next(answer, message)"
                            v-html="answer.answer"
                        ></button>
                    </div>
                    <div
                            class="date"
                            @change="checkBirth"
                            v-if="message.type === 'date'"
                    >
                        <select
                                class="date__item"
                                :class="{'date__item--active': pickedDay}"
                                v-model.trim="pickedDay"
                        >
                            <option value>Day</option>
                            <option v-for="day in days" :value="day">{{day < 10 ? '0' + day : day}}</option>
                        </select>
                        <select
                                class="date__item"
                                :class="{'date__item--active': pickedMonth}"
                                v-model="pickedMonth"
                        >
                            <option value>Month</option>
                            <option v-for="month in months" :value="month">{{month < 10 ? '0' + month : month}}
                            </option>
                        </select>
                        <select
                                class="date__item"
                                :class="{'date__item--active': pickedYear}"
                                v-model="pickedYear"
                        >
                            <option value>Year</option>
                            <option v-for="year in years" :value="year">{{year < 10 ? '0' + year : year}}</option>
                        </select>
                    </div>
                    <span class="message-time">
                        <div class="message-time__text">{{message.time}}</div>
                        <span class="message-delivered" v-if="message.user">
                            <img src="../assets/img/delivered.svg" alt/>
                        </span>
                    </span>
                </div>
                <div class="callButton animated pulse infinite" v-if="midx === messages.length">
                    <a class="button" id="call-link" href="tel:111111111111">
                        <img class="button__icon" src="../assets/img/call-res.svg" alt/>
                        <span class="button__text">
                            Call now
                          </span>
                    </a>
                </div>
                <div class="typing" v-if="typing">
                    {{person}} is typing
                    <span class="dot" v-for="(dot,index) in 3" :key="index"></span>
                </div>
            </div>   
        </div>
        <Footer :view="midx === messages.length"/>
    </section>
</template>


<style lang="scss" scoped>
    @import "../assets/animations.css";

    .avatar__img {
        border-radius: 50%;
    }

    .chat {
        padding-top: 71px;
        background: #ede6de;
        position: relative;
        height: 100%;
    }

    .header {
        background: #00796b;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        height: 71px;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 9999;

        &-wrap {
            padding: 0 15px;
            display: flex;
            align-items: center;
            max-width: 400px;
            margin: 0 auto;
            height: inherit;
        }

        &-avatar {
            margin-right: 11px;
            width: 58px;
            height: 58px;
            position: relative;

            &:after {
                content: "";
                width: 9px;
                height: 9px;
                border: 1px solid #fff;
                background: #3dba2e;
                position: absolute;
                bottom: 6px;
                right: 3px;
                border-radius: 50%;
            }
        }

        &__avatar {
            max-width: 100%;
        }

        &-text {
            color: #ffffff;

            &__name {
                font-size: 14px;
                font-weight: bold;
                line-height: 16px;
            }

            &__who {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.7);
                line-height: 16px;
            }

            &__answers {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.7);
            }
        }
    }

    .main {
        background: url("../assets/img/bg-sign.png"), #ede6de;
        background-size: contain;
        padding: 0 15px 35px 15px;
        max-width: 400px;
        margin: 0 auto;
        height: 100%;
        &-content{
            &-timer{
                width: 100%;
                text-align: center;
                color: #d90000;
                font-size: 12px;
                line-height: 14px;
            }
        }
    }

    .blow {
        padding-top: 25px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        scrollbar-width: none;
        
        &::-webkit-scrollbar {
            width: 0px;
        }
        -ms-overflow-style: none;
    }

    .callButton {
        text-align: center;
        margin: 16px auto;
        width: 90%;
    }
    .button {
        margin: 0 auto;
        display: flex;
        outline: none;
        border: none;
        background: linear-gradient(180deg, #2fc800 0%, #239500 100%);
        border-radius: 50px;
        width: 100%;
        height: 54px;
        text-decoration: none;
        justify-content: center;
        align-items: center;

        &__icon {
            position: absolute;
            top: 9px;
            left: 15px;
            margin-right: 20px;
            animation: tada 1.5s infinite;
        }

        &__text {
            text-align: center;
            text-transform: uppercase;
            color: #ffffff;
            text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
            font-weight: bold;
            font-size: 7vw;

            @media (min-width: 400px) {
                font-size: 28px;
            }
        }
    }
    .message {
        background: #fff;
        border-radius: 0 10px 10px 10px;
        padding: 10px 15px;
        position: relative;
        margin-bottom: 11px;
        width: 100%;
        box-shadow: 0px 0px 1px #a39f98, 0px 1px 1px rgba(164, 152, 135, 0.321416);
        flex-direction: column;

        .container-button {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            margin-top: 15px;

            .container__button {
                border-radius: 25px;
                border: 1px solid black;
                padding: 8px 0;
                color: black;
                font-weight: 500;
                font-size: 14px;
                outline: none;
                width: 35%;
                margin: 5px 0;
                background-color:  #ede6dd;
            }
        }

        &__text {
            color: #000000;
            font-size: 16px;
            line-height: 18px;
            font-weight: normal;
        }

        &-time {
            margin: 5px 0 0 5px;
            align-self: flex-end;
            display: flex;
            align-items: center;

            &__text {
                width: 100%;
                text-align: right;
                color: rgba(0, 0, 0, 0.54);
                font-size: 11px;
            }
        }

        &-delivered {
            width: 19px;
            height: 15px;
            margin-left: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &--user {
            border-radius: 10px 0 10px 10px;
            width: auto;
            background: #e1ffc7;
            color: #fff;
            min-width: 181px;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }

    .typing {
        width: 100%;
        text-align: left;
        color: gray;
        font-size: 12px;
    }

    .fade-enter-active {
        transition: opacity 0.5s;
    }

    .fade-enter {
        opacity: 0;
    }

    .date {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 13px;

        &__item {
            margin-bottom: 5px;
            border-radius: 25px;
            border: none;
            padding: 8px 24px;
            color: #fff;
            font-weight: 500;
            font-size: 14px;
            appearance: none;
            outline: none;
            min-width: 91px;
            text-align: center;
            text-align-last: center;
            position: relative;
            background: url("../assets/img/tringl_sel.svg") no-repeat 90% 50%, #006c60;

            &--active {
                background: url("../assets/img/tringl_sel-active.svg") no-repeat 90% 50%,
                #00796b;
                color: #fff;
                box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
            }

            &:not(:last-child) {
                margin-right: 5.5px;
            }
        }
    }

    .chatInput {
        /*position: fixed;*/
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        /*padding: 10px 18px;*/
        display: flex;
        align-items: center;
        max-width: 400px;
        margin: 0 auto;
        background: #ede6de;
        box-shadow: 0px -1px 1px rgba(0, 0, 0, 0.03);

        &__input {
            width: 90%;
            margin-right: 6px;
            background: #f8f8f8;
            border: 1px solid #ececec;
            border-radius: 16px;
            height: 38px;
            padding: 8px 21px;
            color: #040303;
            font-weight: 300;
            font-size: 14px;
            outline: none;

            &::placeholder {
                color: #040303;
            }

            &:hover {
                &::placeholder {
                    color: transparent;
                }
            }
        }

        &__button {
            border: none;
            outline: none;
            background: none;
            cursor: pointer;
            width: 32px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0;

            img {
                width: 32px;
                height: 32px;
            }
        }
    }

    .firstButton {
        background: linear-gradient(180deg, #0b9d6b 0%, #00796b 100%);
        border-radius: 60px;
        border: none;
        outline: none;
        padding: 19px 50px 18px 70px;
        position: relative;
        text-decoration: none;

        &__img {
            position: absolute;
            width: 50px;
            height: 50px;
            top: 3px;
            left: 3px;
            animation: horoRotate 5s linear infinite;

        }

        &__text {
            text-transform: uppercase;
            color: #ffe7a9;
            font-weight: bold;
            font-size: 16px;
            letter-spacing: 1.3px;
        }
    }

    .dot {
        display: inline-block;
        width: 2px;
        height: 2px;
        border-radius: 50%;
        margin-left: 3px;
        background: #1A1A1B;
        animation: vawe 1.3s linear infinite;

        &:nth-child(2) {
            animation-delay: -1.1s;
        }

        &:nth-child(3) {
            animation-delay: -0.9s;
        }
    }

    @keyframes horoRotate {
        0% {
            transform: rotateZ(0deg)
        }
        100% {
            transform: rotateZ(100deg)
        }
        50% {
            transform: rotateZ(-100deg)
        }
        0% {
            transform: rotateZ(0deg)
        }
    }

    @keyframes vawe {
        0%,
        60%,
        100% {
            transform: initial;
        }

        30% {
            transform: translateY(-7px);
        }
    }
</style>

<script>
    import Footer from "../components/Footer.vue";
    import Timer from "../components/Timer";
    import messages from "../mixins/messages";

    export default {
        data() {
            return {
                midx: 0,
                idx: 0,
                typing: true,
                days: null,
                months: null,
                years: null,
                userBirthDay: null,
                pickedDay: "",
                pickedMonth: "",
                pickedYear: "",
                userMessage: "",
                chatForm: false,
                city: null,
                delivered: [],
                innerHeight: window.innerHeight
            };
        },
        components: {Timer,Footer},
        props: ['person'],
        mixins: [messages],
        methods: {
            scroll() {
                let blow = this.$refs.blow;
                let height = this.$refs.blow.scrollHeight;
                setTimeout(() => {
                    blow.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                });
            },
            next(answer) {
                this.typing = true;
                this.delivered.push({
                    text: `${answer.answer}`,
                    type: 'answer',
                    user: true,
                    time: this.sendedTime()
                });
                this.idx++;
                this.scroll();
                this.chat();
            },
            chat() {
                window.scrollTo(0,0);
                this.typing = true;
                this.chatForm = false;
                let l = setInterval(() => {
                    if(this.messages[this.midx].type !== 'question') {
                        this.typing = true;
                        this.messages[this.midx].time = this.sendedTime();
                        this.delivered.push(this.messages[this.midx]);
                        this.midx++;
                        this.idx++;
                        this.scroll();
                        if(this.midx === this.messages.length) {
                            this.$emit('views', !this.view);
                        }
                        else {
                            this.$emit('views', this.view);
                        }
                        if (
                            this.midx === this.messages.length ||
                            this.messages[this.midx - 1].stop
                        )
                            clearInterval(l), (this.chatForm = true), (this.typing = false);
                        if (this.messages[this.midx + 1] && this.messages[this.midx + 1].city) {
                            this.dynamicText('city', 1);
                        }
                    }
                    else if (this.messages[this.midx].type == 'question') {
                        this.messages[this.midx].time = this.sendedTime();
                        this.delivered.push(this.messages[this.midx]);
                        this.midx++;
                        this.idx++;
                        this.scroll();
                        clearInterval(l), (this.chatForm = true), (this.typing = false);
                    }
                }, 0);
            },
            sec() {
                this.$emit("apa");
            },
            genBirthDay(min, max) {
                let array = [];
                for (let i = min; i <= max; i++) {
                    array.push(i);
                }
                return array;
            },
            sendMessage(message) {
                this.delivered.push({
                    text: message,
                    user: true,
                    time: this.sendedTime()
                });
                this.idx++;
                this.scroll();
                this.chat();
                this.userMessage = "";
            },
            checkBirth() {
                if (this.pickedDay && this.pickedMonth && this.pickedYear) {
                    this.userBirthDay = `${
                        this.pickedDay < 10 ? "0" + this.pickedDay : this.pickedDay
                    }.${
                        this.pickedMonth < 10 ? "0" + this.pickedMonth : this.pickedMonth
                    }.${this.pickedYear}`;
                    this.sendMessage(this.userBirthDay);
                }
            },
            sendedTime() {
                let date = new Date();
                let hours = date.getHours();
                let minutes = date.getMinutes();
                return `${hours < 10 ? "0" + hours : hours}:${
                    minutes < 10 ? "0" + minutes : minutes
                }`;
            },
            getCity: function () {
                var x = location.origin + location.pathname;
                return fetch(x + "./modules/getCity.php").then(function (response) {
                    return response.json();
                });
            }
        },
        created() {
            let app = this;
            this.getCity()
                .then(function (response) {
                    app.city = response.city;
                })
                .catch(console.log());
        },
        mounted() {
            let ths = this;
            this.chat();
            this.days = this.genBirthDay(1, 31);
            this.months = this.genBirthDay(1, 12);
            this.years = this.genBirthDay(
                1940,
                new Date().getFullYear() - 18
            ).reverse();
            window.onresize = () => (this.innerHeight = window.innerHeight);
        }
    };
</script>
